export function BoundingBoxIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M27.332 7.16699C28.7127 7.16699 29.832 6.0477 29.832 4.66699C29.832 3.28628 28.7127 2.16699 27.332 2.16699C25.9513 2.16699 24.832 3.28628 24.832 4.66699C24.832 6.0477 25.9513 7.16699 27.332 7.16699Z'
        stroke='currentColor'
      />
      <circle cx='27.332' cy='27.333' r='2.5' stroke='currentColor' />
      <path
        d='M4.66797 29.833C6.04868 29.833 7.16797 28.7137 7.16797 27.333C7.16797 25.9523 6.04868 24.833 4.66797 24.833C3.28726 24.833 2.16797 25.9523 2.16797 27.333C2.16797 28.7137 3.28726 29.833 4.66797 29.833Z'
        stroke='currentColor'
      />
      <circle cx='4.66797' cy='4.66699' r='2.5' stroke='currentColor' />
      <path
        d='M9.82326 5.33301H22.1741M9.82326 26.6663H22.1741M5.33203 22.1751V9.82424M26.6654 22.1751V9.82424'
        stroke='currentColor'
        strokeLinecap='round'
        strokeDasharray='4 3'
      />
    </svg>
  )
}
